import { useSelector } from 'react-redux';

const useSelectedAssignmentsCount = () => {
  return useSelector((state) => {
    const assignments =
      state.CourseAssignReducer.assignments.studentAssignments || [];

    return assignments.reduce(
      (prev, assignment) => prev + (!!assignment.isSelected && 1),
      0
    );
  });
};

export default useSelectedAssignmentsCount;



// WEBPACK FOOTER //
// ./helpers/hooks/use-selected-assignments-count/use-selected-assignments-count.js